<template>
  <div>
    <v-container>
      <v-card class="pa-8">
        <v-card-title>Notification center</v-card-title>
        <v-divider> </v-divider>
        <v-row class="mt-5">
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  <h2>Schedule configuration</h2>
                </v-card-text>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu1"
                  :disabled="!editBtn"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time_on"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="time_on"
                      label="Power On Alarm"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      style="max-width: 320px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu1 && editBtn"
                    v-model="time_on"
                    full-width
                    @click:minute="$refs.menu1.save(time_on)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu2"
                  :disabled="!editBtn"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time_off"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      style="max-width: 320px"
                      v-model="time_off"
                      label="Power Off Alarm"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu2 && editBtn"
                    v-model="time_off"
                    full-width
                    @click:minute="$refs.menu2.save(time_off)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <!-- <div align="right"> -->
                  <v-col cols="12" class="text-right">
                    <v-btn color="blue-grey"
                        class="white--text mx-2 mb-3" 
                        @click="editBtn = true"
                        >Edit
                    </v-btn>
                    <v-btn color="accent"
                        class="white--text mx-2 mb-3" 
                        @click="saveAlarm(time_on, time_off)"
                        :disabled="time_off === null || time_on === null || editBtn === false"
                        :loading="processing"
                        >Save
                    </v-btn>  
                    <!-- || time_on === alarms.alarmON || time_off === alarms.alarmOFF -->
                  </v-col>
              <!-- </div> -->
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  <h2>Phone Configuration</h2>
                </v-card-text>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="newPhone"
                  style="max-width: 300px"
                  :append-outer-icon="(newPhone[8] && selTag.length > 0) ? 'mdi-send' : ''"
                  label="Add Phone"
                  @click:append-outer="add_phone(newPhone, selTag)"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-chip-group
                  v-model="selTag"
                  value="tag"
                  multiple
                  active-class="green"
                >
                  <v-chip v-for="tag in tags" :key="tag">
                    {{ tag }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  <h2>Phones</h2>
                </v-card-text>
              </v-col>
              <v-col cols="12">
                <div v-if="phones.length > 0">
                    <v-list-item-group>
                        <v-divider></v-divider>
                        <template v-for="(phone, index) in phones">
                            <v-list-item :key="phone.id" color="primary">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ phone.phone }} | 
                                        <strong
                                            ><span v-for="(tag, index) in phone.tag" :key="tag"
                                            ><span v-if="index == 1">and</span>
                                            {{ tags[tag] }}
                                            </span>
                                        </strong>         
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action class="mr-2 my-3">
                                    <v-btn icon @click="deleteWindow(phone.id)">
                                        <v-icon small>mdi-trash-can</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider :key="index" class="ma-0"></v-divider>
                        </template>
                    </v-list-item-group>
                </div>
                <div v-else>
                    <div class="text-center grey--text">
                        <v-icon large>mdi-alarm-check</v-icon>
                        <p>Fill data to add alarms<p/>
                    </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-dialog v-model="open" persistent width="370" class="align-center">
            <template>
                <v-card height="auto">
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title>Delete phone</v-toolbar-title>
                </v-toolbar>
                    <v-form ref="form" class="text-center my-3">
                        Do you want to delete this phone?
                    </v-form>
                    <div align="right" class="align-content-end mx-4">
                        <v-btn color="danger" 
                            small
                            class="white--text mx-2 mb-3" 
                            @click="delete_phone(delTel)"
                            :loading="processing"
                            >Delete
                        </v-btn>
                        <v-btn color="danger" 
                            small 
                            text
                            class="mb-3"
                            @click="open = false"
                            >Cancel
                        </v-btn>
                    </div>
                </v-card>
            </template>
        </v-dialog>
        <v-snackbar v-model="success" :timeout="3000">
            Phone deleted successfully
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="success = false">Close</v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="confirm" :timeout="3000">
            Alarms saved successfully
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="confirm = false">Close</v-btn>
            </template>
        </v-snackbar>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: 'Alarms',
    computed:{
        ...mapState({
            phones: state => state.user.phones,
            alarms: state => state.user.alarms
        })
    },
    data() {
        return {
            editBtn: false,
            time_on: null,
            time_off: null,
            menu1: false,
            menu2: false,
            newPhone: "",
            selTag: [],
            tags: ["Tickets", "Schedules"],
            open: false,
            delTel: "",
            success: false,
            processing: false,
            confirm: false
            // phones: [{ tag: [0, 1], phone: "8154854945" }],
        };
    },
    methods: {
        ...mapActions({ 
            addPhone: 'user/addPhone',
            deletePhone: 'user/deletePhone',
            editAlarm: 'user/editAlarm'
        }),
        add_phone(phone, selTag) {
            this.addPhone({ phone: phone, tag: selTag })
            this.reset()
        },
        deleteWindow(phone){
            this.open = true
            this.delTel = phone
            // console.log(phone)
        },
        async delete_phone(phone){
            this.processing = true
            await this.deletePhone(phone)
            await this.sleep(2000).then(() => { this.processing = false; });
            this.sleep(1000).then(() => { this.open = false; })
            this.success = true
        },
        async saveAlarm(timeOn, timeOff){
            this.processing = true
            // console.log(timeOn, timeOff)
            await this.editAlarm({ alarmON: timeOn, alarmOFF: timeOff })
            await this.sleep(2000).then(() => { this.processing = false; });
            this.editBtn = false
            this.confirm = true
        },
        reset(){
            this.newPhone= ""
            this.selTag = []
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
    },
    created(){
        // console.log(this.alarms)
        if(this.alarms.alarmON != null && this.alarms.alarmOFF != null){
            this.time_on = this.alarms.alarmON
            this.time_off = this.alarms.alarmOFF
        }
        // console.log('Alarm ON:', this.time_on)
        // console.log('Alarm OFF:', this.time_off)
    },
};
</script>

<style scoped>
.save{
  position: relative;
  left: 265px
}
</style>